"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailableDrillTargetMeasure = exports.AttributeDisplayFormType = exports.isDrillToUrlConfig = exports.isDrillToAttributeUrlConfig = exports.isDrillToCustomUrlConfig = exports.isDrillToInsightConfig = exports.isDrillToDashboardConfig = exports.DRILL_TARGET_TYPE = exports.isDrillToUrl = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_model_1 = require("@gooddata/sdk-model");
function isDrillToUrl(drillDefinition) {
    return sdk_model_1.isDrillToCustomUrl(drillDefinition) || sdk_model_1.isDrillToAttributeUrl(drillDefinition);
}
exports.isDrillToUrl = isDrillToUrl;
var DRILL_TARGET_TYPE;
(function (DRILL_TARGET_TYPE) {
    DRILL_TARGET_TYPE["DRILL_TO_DASHBOARD"] = "DrillToDashboard";
    DRILL_TARGET_TYPE["DRILL_TO_INSIGHT"] = "DrillToInsight";
    DRILL_TARGET_TYPE["DRILL_TO_URL"] = "DrillToUrl";
})(DRILL_TARGET_TYPE = exports.DRILL_TARGET_TYPE || (exports.DRILL_TARGET_TYPE = {}));
function isDrillToDashboardConfig(item) {
    return !isEmpty_1.default(item) && item.dashboard !== undefined;
}
exports.isDrillToDashboardConfig = isDrillToDashboardConfig;
function isDrillToInsightConfig(item) {
    return !isEmpty_1.default(item) && item.insightRef !== undefined;
}
exports.isDrillToInsightConfig = isDrillToInsightConfig;
function isDrillToCustomUrlConfig(item) {
    return !isEmpty_1.default(item) && item.customUrl !== undefined;
}
exports.isDrillToCustomUrlConfig = isDrillToCustomUrlConfig;
function isDrillToAttributeUrlConfig(item) {
    return !isEmpty_1.default(item) && item.insightAttributeDisplayForm !== undefined;
}
exports.isDrillToAttributeUrlConfig = isDrillToAttributeUrlConfig;
function isDrillToUrlConfig(item) {
    return !isEmpty_1.default(item) && item.urlDrillTarget !== undefined;
}
exports.isDrillToUrlConfig = isDrillToUrlConfig;
// check type AttributeDisplayFormType from @gooddata/sdk-model to keep it in sync
var AttributeDisplayFormType;
(function (AttributeDisplayFormType) {
    AttributeDisplayFormType["HYPERLINK"] = "GDC.link";
    AttributeDisplayFormType["GEO_PUSHPIN"] = "GDC.geo.pin";
    AttributeDisplayFormType["GEO_PUSHPIN_LATITUDE"] = "GDC.geo.pin_latitude";
    AttributeDisplayFormType["GEO_PUSHPIN_LONGITUDE"] = "GDC.geo.pin_longitude";
})(AttributeDisplayFormType = exports.AttributeDisplayFormType || (exports.AttributeDisplayFormType = {}));
function isAvailableDrillTargetMeasure(obj) {
    return !isEmpty_1.default(obj) && obj.measure !== undefined;
}
exports.isAvailableDrillTargetMeasure = isAvailableDrillTargetMeasure;
//# sourceMappingURL=types.js.map